// extracted by mini-css-extract-plugin
module.exports = {"paymentDueBanner":"PaymentDueBanner_paymentDueBanner__1AifQ","bannerText":"PaymentDueBanner_bannerText__3A_bf"};